/**
 * purchaseRiFamilySize模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const purchaseRiFamilySize = {
  // 分页查询
  pagingQuery(params) {
    return $http.post(`${global.API_URL}/sme/purchaseRiFamilySize/pagingQuery`,params);
  },
  // 编辑
  update(params) {
    return $http.post(`${global.API_URL}/sme/purchaseRiFamilySize/update`,params);
  }
}

export default purchaseRiFamilySize;



// WEBPACK FOOTER //
// ./src/api/purchaseRiFamilySize.js